import type { NavId } from "../components/AppShell";

const KEY = "st_post_login_nav";

export function rememberNavForAfterAuthRedirect(nav: NavId): void {
  sessionStorage.setItem(KEY, nav);
}

/** Read and clear one-shot nav restore after Auth0 redirects to origin (`/`). */
export function consumeInitialNavFromAuthRedirect(): NavId | null {
  const v = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  if (
    v === "dashboard" ||
    v === "subscriptions" ||
    v === "settings" ||
    v === "account"
  )
    return v;
  return null;
}
